import { UplogCredentialForm } from '@/components/uplog/UplogCredentialForm';
import { ScannerConfig } from '@/components/uplog/ScannerConfig';
import { DispatchConfig } from '@/components/uplog/DispatchConfig';
import { PendenciasTable } from '@/components/uplog/PendenciasTable';
import { DispatchLogTable } from '@/components/uplog/DispatchLogTable';

export function UplogSettingsPage() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-semibold">UpLog Disparos</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Integração financeira — consulta de pendências, detecção de boletos e disparo automático via WhatsApp.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <UplogCredentialForm />
        <ScannerConfig />
        <DispatchConfig />
      </div>

      <PendenciasTable />
      <DispatchLogTable />
    </div>
  );
}
